import { promises } from "dns";
import {
  pageTypes,
  createWPSWordInSpace,
  createPageInFile,
  createTableInFile,
  createPrivateWps,
  WPSType,
  createMind
} from "../../api/createmenu";
import { PageType as PageTypeEnum } from "../../const";
export const PageType = {
  page: pageTypes[1], // 文档
  report: pageTypes[2], // 报告
  sheet: pageTypes[4], // 表格
  link: pageTypes[5], // link
  file: pageTypes[6], // 文件
  websheet: pageTypes[7], // websheet
  wpsWord: WPSType.word,
  wpsexcel: WPSType.excel,
  wpsPPT: WPSType.ppt,
  mind: pageTypes[8] // mind
};

const ApiByPageType = {
  [PageType.page]: createPageInFile,
  [PageType.sheet]: createTableInFile,
  [PageType.wpsWord]: createPrivateWps,
  [PageType.wpsexcel]: createPrivateWps,
  [PageType.wpsPPT]: createPrivateWps,
  [PageType.mind]: createMind
};

export const pageTypeNumber = {
  PAGE: 1, // 文档
  REPORT: 2,
  NOTE: 3,
  SHEET: 4, // 表格
  LINK: 5,
  FILE: 6,
  MIND: 10 // 脑图
};

/**
 * 根据类型创建文档
 */
export const createDocumentByPageType = (
  type: string,
  folderId: string,
  gid: string,
  folderName?: string
  // eslint-disable-next-line max-params
) => {
  let method = ApiByPageType[type];
  let params;
  switch (type) {
    case PageType.sheet:
    case PageType.mind:
      params = { folderId, gid };
      break;
    case PageType.page:
      params = { folderId, gid };
      break;
    case PageType.wpsWord:
    case PageType.wpsexcel:
    case PageType.wpsPPT:
      params = {
        pageType: type === PageType.wpsWord ? 11 : type === PageType.wpsexcel ? 12 : 13,
        folderId
        // gid
      };
  }
  // @ts-ignore
  return method(params, folderName);
};
